/**************************************************
 * Nombre:       Dashboard
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import DashboardBase from "../Modulo_Dashboard/Componentes/DashboardBase";
import React, {createContext, useState} from "react";
import {
    AutoAwesomeMotionOutlined,
    AutoStoriesOutlined,
    BadgeOutlined,
    CategoryOutlined,
    CoffeeMakerOutlined,
    FactCheckOutlined,
    FastfoodOutlined,
    FastForwardOutlined,
    LocalFireDepartmentOutlined,
    TableRestaurantOutlined,
    WarehouseOutlined,
    ZoomInMapOutlined
} from "@mui/icons-material";
import {funSalir} from "../Servicios/Auth/funSalir";
import Seccion_Usuarios from "./Secciones/Seccion_Usuarios";
import Seccion_Config_Mesas from "./Secciones/Seccion_Config_Mesas";
import Seccion_Mesas_Dia from "./Secciones/Seccion_Mesas_Dia";
import Seccion_Reservaciones from "./Secciones/Seccion_Reservaciones";
import Seccion_Fila from "./Secciones/Seccion_Fila";
import Seccion_Config_Sectores from "./Secciones/Seccion_Config_Sectores";
import Seccion_Comandas from "./Secciones/Seccion_Comandas";
import Seccion_Productos from "./Secciones/Seccion_Productos";
import Seccion_Categorias from "./Secciones/Seccion_Categorias";
import Seccion_Zonas_Produccion from "./Secciones/Seccion_Zonas_Produccion";
import Seccion_Inventario from "./Secciones/Seccion_Inventario";
import Seccion_Produccion from "./Secciones/Seccion_Produccion";


export const contexBarra = createContext()
const Dashboard = () => {
    const [notificaciones, setNotificaciones] = useState([])
    const [nuevasNotificaciones, setNuevasNotificaciones] = useState(0)
    const [historial, setHistorial] = useState([])
    const [nuevoHistorial, setNuevoHistorial] = useState(0)

    const salir = () => {
        funSalir()
    }

    const valoresBarra = {
        notificaciones,
        nuevasNotificaciones,
        historial,
        nuevoHistorial,
        funSalir: salir

    }


    const {Provider} = contexBarra;


    return (
        <Grid
            container
            size={12}
        >

            <Provider value={valoresBarra}>
                <DashboardBase secciones={secciones} seccionesPerfil={seccionesPerfil} seccionesID={seccionesID}/>
            </Provider>


        </Grid>
    )

}
export default Dashboard

let secciones = [
    {
        nombre: 'Mesas',
        icono: TableRestaurantOutlined,
        camino: '/Mesas',
        categoria: 'Inicio',
        Componente: <Seccion_Mesas_Dia/>
    },
    {
        nombre: 'Fila',
        icono: FastForwardOutlined,
        camino: '/Fila',
        categoria: 'Inicio',
        Componente: <Seccion_Fila/>
    },
    {
        nombre: 'Comandas',
        icono: FactCheckOutlined,
        camino: '/Comandas',
        categoria: 'Inicio',
        Componente: <Seccion_Comandas/>
    },
    {
        nombre: 'Reservaciones',
        icono: AutoStoriesOutlined,
        camino: '/Reservaciones',
        categoria: 'Inicio',
        Componente: <Seccion_Reservaciones/>
    },
    {
        nombre: 'Produccion',
        icono: LocalFireDepartmentOutlined,
        camino: '/Produccion',
        categoria: 'Inicio',
        Componente: <Seccion_Produccion/>
    },
    {
        nombre: 'Productos',
        icono: FastfoodOutlined,
        camino: '/Productos',
        categoria: 'Configuraciones',
        Componente: <Seccion_Productos/>
    },
    {
        nombre: 'Inventario',
        icono: WarehouseOutlined,
        camino: '/Inventario',
        categoria: 'Configuraciones',
        Componente: <Seccion_Inventario/>
    },
    {
        nombre: 'Categorias',
        icono: CategoryOutlined,
        camino: '/Categorias',
        categoria: 'Configuraciones',
        Componente: <Seccion_Categorias/>
    },
    {
        nombre: 'Config Mesas',
        icono: AutoAwesomeMotionOutlined,
        camino: '/ConfigMesas',
        categoria: 'Configuraciones',
        Componente: <Seccion_Config_Mesas/>
    },
    {
        nombre: 'Config Sectores',
        icono: ZoomInMapOutlined,
        camino: '/ConfigSectores',
        categoria: 'Configuraciones',
        Componente: <Seccion_Config_Sectores/>
    },
    {
        nombre: 'Zonas Produccion',
        icono: CoffeeMakerOutlined,
        camino: '/Zonas',
        categoria: 'Configuraciones',
        Componente: <Seccion_Zonas_Produccion/>
    },
    {
        nombre: 'Usuarios',
        icono: BadgeOutlined,
        camino: '/Usuarios',
        categoria: 'Configuraciones',
        privada: false,
        Componente: <Seccion_Usuarios/>
    }
];


const seccionesID = []

const seccionesPerfil = []

const notificaciones = {}